<div class="mb-3" *ngIf="pending">
  <div class="d-flex justify-content-end text-main font-weight-bold mb-2" *ngIf="progress && pending">{{ progress }}%</div>
  <div class="progress">
    <div class="progress-bar" role="progressbar" [style.width]="progress + '%'" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</div>
